import camelCase from 'lodash/camelCase';

export default (accessRules = []) => accessRules.reduce((acc, rule) => {
    const key = camelCase(rule.class_type);
    acc[key] = {
      access: rule.access,
      enforcement_rule: rule.enforcement_rule,
    };
    return acc;
  }, {});
